export default "__VITE_ASSET__DIEiMO1A__"